import { render, staticRenderFns } from "./ModelTags.vue?vue&type=template&id=fe0cc858&scoped=true"
import script from "./ModelTags.vue?vue&type=script&lang=js"
export * from "./ModelTags.vue?vue&type=script&lang=js"
import style0 from "./ModelTags.vue?vue&type=style&index=0&id=fe0cc858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0cc858",
  null
  
)

export default component.exports